const capitalizeFirstLetter = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const CapitalizeFirstLetter = capitalizeFirstLetter;
export default CapitalizeFirstLetter;
